import merge from "lodash.merge";
import { ApplicationStyles } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/default/config/application/application_styles.config";
import { DivisionLineStyles } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/default/config/application/division-line.config";
import { defaultTheme } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/default/default-theme";
import { ApplicationFlatStyles } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/flat/config/application/application_styles.config";
import { FlatDivisionLineStyles } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/flat/config/application/division-line.config";
import { FocusFlatStyles } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/flat/config/application/focus.config";
import { HoverFlatStyles } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/flat/config/application/hover.config";
import { ModulFApplicationStyles } from "./application";
import { ModulFFocusStyles } from "./focus";
import { ModulFHoverStyles } from "./hover";
export function applyModulFStyles(params) {
    const focusStyles = merge({}, FocusFlatStyles(params), ModulFFocusStyles(params));
    const hoverStyles = merge({}, HoverFlatStyles(params), ModulFHoverStyles(params));
    const applicationStyles = merge({}, ApplicationStyles(params), ApplicationFlatStyles({ hoverStyles }), ModulFApplicationStyles(params));
    const divisionLineStyles = merge({}, DivisionLineStyles(params), FlatDivisionLineStyles());
    return {
        ...params,
        baseInputStyles: defaultTheme.baseInputStyles,
        applicationStyles,
        focusStyles,
        hoverStyles,
        divisionLineStyles
    };
}
